import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  FormControlLabel,
  Modal,
  Stack,
  Checkbox,
  Typography,
} from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import "../App.css";
import Navbar from "../components/Navbar";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import RequestImage from "../assets/Images/request_submitted.png";
import EscrowButton from "../components/EscrowButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PaymentMethod = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("card");
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [Expiry, setExpiry] = useState("");
  const [CVV, setCVV] = useState("");
  const [focus, setFocus] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/login");
    }
    // console.log("location", location.state.currentRequest);
  }, []);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <img
              src={RequestImage}
              alt="MenuIcon"
              style={{ width: "300px", height: "300px" }}
            />
            <Typography style={{ fontWeight: "bold" }}>
              Booking confirmed
            </Typography>
            <Typography style={{ textAlign: "center" }}>
              Your booking confirmed with{" "}
              {location.state.currentRequest.serviceProviderName}. Thank you for
              trusting us.
            </Typography>
            <Button
              variant="contained"
              className="primary-button"
              style={{ textTransform: "capitalize" }}
            >
              View Booking
            </Button>
          </Stack>
        </Box>
        {/* <div>
          <img src={RequestImage} alt="MenuIcon" />
        </div> */}
      </Modal>
      <Navbar />

      <Container className="" maxWidth="sm">
        <Box>
          <h2>Add Payment Method</h2>
          <Typography
            style={{ color: "rgba(122, 122, 128, 1)" }}
            className="mb-10"
          >
            You won’t be charged unless service is delivered. Your payment will
            be saved in escrow.
          </Typography>
          <Stack spacing={2} direction="column">
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="center"
              style={{
                backgroundColor: "#F5F5F5",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <div
                style={{ width: "50%", textAlign: "center", cursor: "pointer" }}
                className={
                  selectedPaymentMethod == "card"
                    ? "selected-payment-method"
                    : ""
                }
                onClick={() => setSelectedPaymentMethod("card")}
              >
                <Typography>Card</Typography>
              </div>
              <div
                style={{ width: "50%", textAlign: "center", cursor: "pointer" }}
                className={
                  selectedPaymentMethod == "paypal"
                    ? "selected-payment-method"
                    : ""
                }
                onClick={() => setSelectedPaymentMethod("paypal")}
              >
                <Typography>Paypal</Typography>
              </div>
            </Stack>
            {selectedPaymentMethod == "card" ? (
              <>
                <Cards
                  cvc={CVV}
                  expiry={Expiry}
                  focused={focus}
                  name={cardName}
                  number={cardNumber}
                />
                <Stack>
                  <Typography style={{ fontWeight: "bold" }}>
                    Card Number
                  </Typography>
                  <TextField
                    required
                    type="number"
                    size="small"
                    id="outlined-basic"
                    variant="outlined"
                    className="w-100"
                    value={cardNumber}
                    placeholder="Enter 16 digit number on your card"
                    onChange={(e) => {
                      if (e.target.value.length <= 16) {
                        setCardNumber(e.target.value);
                      }
                    }}
                    onFocus={() => setFocus("number")}
                    // value={enteredTitle}
                    // onChange={(e) => setEnteredTitle(e.target.value)}
                  />
                </Stack>
                <Stack>
                  <Typography style={{ fontWeight: "bold" }}>
                    Card Name
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    variant="outlined"
                    className="w-100"
                    value={cardName}
                    placeholder="Enter card holder name"
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setCardName(e.target.value);
                      }
                    }}
                    onFocus={() => setFocus("name")}
                    // value={enteredTitle}
                    // onChange={(e) => setEnteredTitle(e.target.value)}
                  />
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Stack>
                    <Typography style={{ fontWeight: "bold" }}>
                      Expiry
                    </Typography>
                    <TextField
                      required
                      type="number"
                      size="small"
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100"
                      placeholder="MM/YY"
                      value={Expiry}
                      onChange={(e) => {
                        if (e.target.value.length <= 4) {
                          setExpiry(e.target.value);
                        }
                      }}
                      onFocus={() => setFocus("expiry")}
                      // value={enteredTitle}
                      // onChange={(e) => setEnteredTitle(e.target.value)}
                    />
                  </Stack>
                  <Stack>
                    <Typography style={{ fontWeight: "bold" }}>CVV</Typography>
                    <TextField
                      required
                      size="small"
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100"
                      value={CVV}
                      placeholder="Enter CVV"
                      onChange={(e) => {
                        if (e.target.value.length <= 3) {
                          setCVV(e.target.value);
                        }
                      }}
                      onFocus={() => setFocus("cvc")}
                      // value={enteredTitle}
                      // onChange={(e) => setEnteredTitle(e.target.value)}
                    />
                  </Stack>
                </Stack>
              </>
            ) : (
              <></>
            )}
          </Stack>
          <FormControlLabel
            control={<Checkbox defaultChecked />}
            label="Save payment information for future purchases."
            className="mt-5 mb-10"
          />
          <Button
            variant="contained"
            className="w-100 primary-button"
            onClick={handleOpen}
          >
            Confirm Booking
          </Button>

          {/* escrow button */}
          <EscrowButton />

          {/* <div className="payment-card mb-4">
            <Button
              variant="contained"
              type="submit"
              className="mt-13 w-43 white-contained-button"
            >
              Go Back
            </Button>
            <Link to="/booking-confirmed">
              <Button variant="contained" type="submit" className="mt-13">
                Continue to Book
              </Button>
            </Link>
          </div> */}
        </Box>
      </Container>
      {/* <Footer /> */}
    </>
  );

  //   return <div className="main-containter">
  //     <Card >
  //    <span>
  //     <h3 className="ml-9">
  //       Log In
  //     </h3>
  //     <p className="ml-9">Please create and account and stay updated.</p>
  //     </span>
  //     <form action="submit" className="login-form">
  //     <TextField id="outlined-basic" label="Email Address" variant="outlined" />
  //     <TextField id="outlined-basic" label="Password" variant="outlined" type='password' className="mt-13" />
  //     <span className="text-align-center">
  //     <Button variant="contained" type='submit' className="mt-13 w-43">Login</Button>
  //     </span>

  //       <span className="text-align-center mt-8 mb-8">OR</span>
  //       <span className="text-align-center">
  //       <Button variant="outlined" className="login-with-google-btn mb-6">Sign in with Google</Button>
  //       {/* <Button variant="contained" class="login-with-google-btn" >
  //   Sign in with Google
  // </Button> */}
  // </span>
  // <span className="text-align-center mb-6">Don't have an account? <a href="#" className="text-decoration-none text-bold">Login Here</a></span>
  //     </form>
  //     </Card>
  //   </div>;
};

export default PaymentMethod;
